import { Interpolation } from '@emotion/css'
import { Theme } from 'src/theme/theme'

const styles = {
  formCard: (theme: Theme): Interpolation => ({
    background: theme.colors.white,
    padding: '63px 15px 25px 15px',
    borderRadius: 10,
    marginTop: -45,
    marginLeft: -15,
    zIndex: -1,
  }),
}

export default styles
